import { useEffect, useRef, useState, type ReactNode } from 'react';

import { cn } from '@heidi/utils';

/** Visible 4px slide when a held send is refused again. */
export function CreditAllowanceBannerNudge({
  nudgeNonce,
  children,
}: {
  nudgeNonce: number;
  children: ReactNode;
}) {
  const [nudging, setNudging] = useState(false);
  const prevNonceRef = useRef(nudgeNonce);

  useEffect(() => {
    if (prevNonceRef.current === nudgeNonce) return;
    prevNonceRef.current = nudgeNonce;
    setNudging(true);
    const id = window.setTimeout(() => setNudging(false), 200);
    return () => window.clearTimeout(id);
  }, [nudgeNonce]);

  return (
    <div
      className={cn(
        'w-full min-w-0',
        'motion-safe:transition-transform motion-safe:duration-200 motion-safe:ease-out-quart',
        nudging && 'motion-safe:-translate-x-1'
      )}
    >
      {children}
    </div>
  );
}
